<template>
  <section class="te-bg-ordermade-cta">
    <div class="co-container-md relative overflow-hidden">
      <div class="relative z-10 w-full p-4 pb-32 md:w-3/5 md:py-10 md:pl-4">
        <div class="mb-8 bg-co-gray-50 p-3 shadow-lg md:px-5 md:py-4">
          <h3 class="te-cta-title mb-5 font-bold leading-normal">
            無料相談でコースに関する疑問や不明点を<br class="hidden sm:block">ご気軽にご相談ください
          </h3>
          <div class="text-co-gray-600">
            <p class="mb-4">
              当コースの流れや学べる内容について、カウンセラーが丁寧にご説明いたします。目標や学びたいスキルがまだ明確でなくても、カウンセラーとの対話を通じて次のステップに繋がる可能性があります。
            </p>
            <p class="mb-0">
              ぜひお気軽にご利用ください。
            </p>
          </div>
        </div>
        <a
          href="/counseling/htmlcss-schedule"
          class="bot_open co-btn-counseling rounded-full"
        >
          まずは相談してみる
          <i
            class="fa fa-angle-right ml-2"
            aria-hidden="true"
          />
        </a>
      </div>
      <div class="absolute bottom-0 right-0 md:top-0">
        <img
          src="~/assets/images/Te/TeCourse/Ordermade/Cta/cta-photo.webp"
          width="638"
          height="464"
          loading="lazy"
          alt="カウンセラー"
        >
      </div>
    </div>
  </section>
</template>

<style scoped>
.te-bg-ordermade-cta {
  background: linear-gradient(90deg, #BEF0D2 0%, #E6FAE6 100%);
}

.te-cta-title {
  font-size: 1.125rem;
  @media (min-width: 768px) {
    font-size: 1.75rem;
  }
}

</style>
